declare function require(moduleName: string): any;
export const ModalBox = require('exports-loader?Coveo.ModalBox!modal-box');
export const LocaleString = require('exports-loader?window.String.toLocaleString!l10n');



// WEBPACK FOOTER //
// ./src/ExternalModulesShim.ts